declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_localized_default_value_foo extends $mol_object {
		b( next?: string ): string
		a( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_localized_default_value_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_localized_default_value_foo['b'] >
	}
	
}

//# sourceMappingURL=bidi_localized_default_value.view.tree.d.ts.map